/* Custom Sugar image deterrents — unobtrusive, no changes to SEO markup or controls. */
(function () {
  'use strict';
  function protectedImage(target) {
    if (!(target instanceof Element)) return null;
    var image = target.closest('img');
    if (!image) return null;
    if (image.closest('[contenteditable="true"], [data-cs-image-protection-exempt], .shopify-section--apps, .shopify-app-block')) return null;
    return image;
  }
  document.addEventListener('contextmenu', function (event) {
    if (protectedImage(event.target)) event.preventDefault();
  }, { capture: true });
  document.addEventListener('dragstart', function (event) {
    if (protectedImage(event.target)) event.preventDefault();
  }, { capture: true });
  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('cs-image-deterrence');
  });
}());